import axios from 'axios';
import config from 'config';
import { join } from 'lodash';

const getHostname = (v) => {
  const version = v || 2;
  const splittedHost = window.location.host.split('.');
  if (splittedHost[0].includes('localhost') || splittedHost[0].includes('127.0.1')) {
    return config.api.hostName[version];
  }
  splittedHost[0] = `https://${config.api.hostDomain[version]}`;
  return join(splittedHost, '.');
};

const authenticatorApiWrapper = axios.create({
  baseURL: `${getHostname()}/cms-fury`,
});

export default (opts) => authenticatorApiWrapper.request(opts);
